import comp from "./HistoryList";
export default comp;
